module.exports = __webpack_public_path__ + "static/media/OnboardingClose.3aba7009.svg";